import _ from 'lodash';

const logStyles = {
  DEPRECATION: 'color: #ced100;',
  DEBUG:       'color: #157841',
  ERROR:       'color: #ee2f19',
  INFO:        'color: #77d3c6;',
  WARN:        'color: #eb8e1b;',
};

/**
 * TODO Should we support different debug levels
 * Log a debug in development environments or if overriden
 * @param {string|object} msg - debug message
 * @param {boolean} [predicate=true] - only will log if true
 */
function debug(msg, predicate = true) {
  if (!isProduction() || isOverridden(logTypes.DEBUG)) {
    if (predicate) {
      _.isString(msg) ?
        console.log('%cLogger => DEBUG: %s', logStyles.DEBUG, msg) :
        console.log('%cLogger => DEBUG: %o', logStyles.DEBUG, msg);
    }
  }
}

/**
 * TODO - Should we support something like a version number? Not sure our releases are predictable enough to go that route. Would give something to grep on
 * Log a deprecation in development environments
 * @param {string} msg - error message
 * @param {boolean} [predicate=true] - only will log if true
 */
function deprecation(msg, predicate = true) {
  if (!isProduction() || isOverridden(logTypes.DEPRECATION)) {
    if (predicate) {
      console.warn(`%cLogger => DEPRECATION: ${msg}`, logStyles.DEPRECATION);
    }
  }
}

/**
 * Log an error in development environments or if overriden
 * @param {string|object} msg - error message
 * @param {boolean} [predicate=true] - only will log if true
 */
function error(msg, predicate = true) {
  if (predicate) {
    _.isString(msg) ?
      console.error('%cLogger => ERROR: %s', logStyles.ERROR, msg) :
      console.error('%cLogger => ERROR: %o', logStyles.ERROR, msg);
  }
}

/**
 * Log a info in development environments or if overriden
 * @param {string} msg - info message
 * @param {boolean} [predicate=true] - only will log if true
 */
function info(msg, predicate = true) {
  if (!isProduction() || isOverridden(logTypes.INFO)) {
    if (predicate) {
      console.log(`%cLogger => INFO: ${msg}`, logStyles.INFO);
    }
  }
}

/**
 * Log a warning in development environments or if overridden
 * @param {string|object} msg - warning message
 * @param {boolean} [predicate=true] - only will log if true
 */
function warn(msg, predicate = true) {
  if (predicate) {
    _.isString(msg) ?
      console.warn('%cLogger => WARN: %s', logStyles.WARN, msg) :
      console.warn('%cLogger => WARN: %o', logStyles.WARN, msg);
  }
}

function groupAll(label, loggers = () => {}) {
  console.groupCollapsed(label);
  loggers.call();
  console.groupEnd();
}

function groupStart(label = 'Logger group') {
  console.groupCollapsed(label);
}

function groupEnd() {
  console.groupEnd();
}

/**
 * An enum of log types
 * @readonly
 * @enum {string}
 */
export const logTypes = {
  DEBUG:       'debug',
  DEPRECATION: 'deprecation',
  INFO:        'info',
  ERROR:       'error',
  WARN:        'warn',
};

/**
 * Returns true if current environment is production based on the NODE_ENV process value
 * @returns {boolean}
 */
function isProduction() {
  return process.env.NODE_ENV === 'production';
}

/**
 * In production, you might want to temporarily turn on logging to debug a problem.
 * You can turn on all logTypes by setting "loggerOverride: true" in local storage
 * You can selectively turn on logTypes by setting "loggerOverride: 'debug,error'" in local storage
 * You can selectively turn on an individual logType by setting "loggerOverride: 'debug'" in local storage
 * @param {string} logType - the logType to check for an override of
 * @returns {boolean}
 */
function isOverridden(logType) {
  const override = window.localStorage.getItem('loggerOverride') || 'false';

  // e.g. 'true'
  if (override === 'true' || override === 'false') {
    return override === 'true';
    // e.g. 'debug, warn'
  } else if (_.includes(override, ', ')) {
    return _.includes(_.split(override, ', '), logType);
    // e.g. 'debug,warn'
  } else if (_.includes(override, ',')) {
    return _.includes(_.split(override, ','), logType);
    // e.g. 'debug'
  } else if (_.includes(_.values(logTypes), override)) {
    return override === logType;
  } else {
    console.warn(
      `Unknown localStorage value for key "loggerOverride"; must be a boolean, a single known logType or an array of known logTypes: ${override}`
    );
    return false;
  }
}

export const _test = {
  isOverridden,
  logTypes,
};

export default {
  debug,
  deprecation,
  error,
  groupAll,
  groupStart,
  groupEnd,
  info,
  warn,
};
